import { request, type RequestOptions } from '@umijs/max';

export const get = <R = any, P = Record<string, any>>(url: string, params?: P, options?: RequestOptions) => {
  return request<IBaseResponse<R>>(url, {
    method: 'GET',
    params,
    ...options,
  });
};

export const post = <R = any, D = any>(url: string, data?: D, options?: RequestOptions) => {
  return request<IBaseResponse<R>>(url, {
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
    ...options,
  });
};

export const put = <R = any, D = any>(url: string, data?: D, options?: RequestOptions) => {
  return request<IBaseResponse<R>>(url, {
    method: 'PUT',
    data,
    ...options,
  });
};

export const del = <R = any, D = any>(url: string, data?: D, options?: RequestOptions) => {
  return request<IBaseResponse<R>>(url, {
    method: 'DELETE',
    data,
    ...options,
  });
};
